const salesTypes = [
  { label: "Topup Guest Shake", value: "topup_guest_shake" },
  { label: "Guest Shake", value: "guest_shake" },
  { label: "TopUp Associate Shake", value: "topup_associate_shake" },
  { label: "Associate Shake", value: "associate_shake" },
  { label: "Compliementary", value: "compliementary" },
  { label: "Retail Shake", value: "retail_sales" },
  { label: "Donation", value: "donation" },
];

const paymentMethods = [
  { label: "Cash", value: "cash" },
  { label: "QR", value: "qr" },
  { label: "Debit Card", value: "debit_card" },
  { label: "UPI", value: "upi" },
  { label: "Net Banking", value: "net_banking" },
  { label: "Wallet", value: "wallet" },
];

const subscriptionDetails = [
  {
    id: "daily",
    title: "Daily Subscription",
    description: "Access all features for a single day.",
    price: 200, // price per day
    type: "daily",
  },
  {
    id: "monthly",
    title: "Monthly Subscription",
    description: "Unlimited access for 30 days.",
    price: 6000,
    type: "monthly",
    days: 30,
  },
  {
    id: "custom",
    title: "Custom Subscription",
    description: "Choose your own start and end date for subscription.",
    pricePerDay: 200, // price can be calculated based on days
    type: "custom",
    customDate: {
      startDate: null, // to be set by user
      endDate: null, // to be set by user
    },
  },
];

const userRoles = [
  { label: "Customer", value: "customer" },
  { label: "Associate", value: "associate" },
  { label: "Preferred Customer", value: "preferred_customer" },
  { label: "Admin", value: "admin" },
  { label: "User", value: "user" },
];

const genderOptions = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
];

const maritalStatus = [
  { label: "Single", value: "single" },
  { label: "Married", value: "married" },
  { label: "Divorced", value: "divorced" },
  { label: "Widowed", value: "widowed" },
];

const pregnancyStatus = [
  { label: "Not Pregnant", value: "not_pregnant" },
  { label: "Pregnant", value: "pregnant" },
  { label: "Post Partum", value: "post_partum" },
];

const bloodGroups = [
  { label: "A+", value: "a_positive" },
  { label: "A-", value: "a_negative" },
  { label: "B+", value: "b_positive" },
  { label: "B-", value: "b_negative" },
  { label: "AB+", value: "ab_positive" },
  { label: "AB-", value: "ab_negative" },
  { label: "O+", value: "o_positive" },
  { label: "O-", value: "o_negative" },
];

const fitnessGoals = [
  { label: "Weight Loss", value: "weight_loss" },
  { label: "Weight Gain", value: "weight_gain" },
  { label: "Muscle Building", value: "muscle_building" },
  { label: "Maintain Health", value: "maintain_health" },
  { label: "Improve Fitness", value: "improve_fitness" },
  { label: "Better Nutrition", value: "better_nutrition" },
];

const activityLevels = [
  { label: "Sedentary (Little or no exercise)", value: "sedentary" },
  { label: "Lightly Active (1-3 days/week)", value: "lightly_active" },
  { label: "Moderately Active (3-5 days/week)", value: "moderately_active" },
  { label: "Very Active (6-7 days/week)", value: "very_active" },
  { label: "Extremely Active (Athlete)", value: "extremely_active" },
];

const dietaryPreferences = [
  { label: "Vegetarian", value: "vegetarian" },
  { label: "Non-Vegetarian", value: "non_vegetarian" },
  { label: "Vegan", value: "vegan" },
  { label: "Eggetarian", value: "eggetarian" },
  { label: "No Preference", value: "no_preference" },
];

export {
  salesTypes,
  paymentMethods,
  subscriptionDetails,
  userRoles,
  genderOptions,
  maritalStatus,
  pregnancyStatus,
  bloodGroups,
  fitnessGoals,
  activityLevels,
  dietaryPreferences,
};
